import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "15",
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0.699219 7.49922L6.99922 7.49922M6.99922 7.49922H13.2992M6.99922 7.49922L6.99922 1.19922M6.99922 7.49922L6.99922 13.7992",
      stroke: "#AA1E2D",
      "stroke-width": "1.4",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }